import React from 'react';
import mascotLogo from '../assets/mascot-logo.png';
import { Box } from '@mui/material';

const Logo = ({ height = '50px' }) => {
  return (
    <Box
      component="img"
      src={mascotLogo}
      alt="Mascott Equipment Co. Logo"
      sx={{
        height: height,
        width: 'auto',
        maxWidth: '100%'
      }}
    />
  );
};

export default Logo;